import { userReducer } from './userReducer';
import { vehicleReducer } from './vehicleReducer';
import { propertyReducer } from './propertyReducer';
import { employmentReducer } from './employmentReducer';
import { residencyReducer } from './residencyReducer';
import { assetsAndNetWorthReducer } from './assetsAndNetWorthReducer';
import { ratesReducer } from './ratesReducer';
import { contactReducer } from './contactReducer';
import { surveyReducer } from './surveyReducer';
import { partnerReducer } from './partnerReducer';

const reducers = {
  userReducer,
  vehicleReducer,
  propertyReducer,
  employmentReducer,
  residencyReducer,
  assetsAndNetWorthReducer,
  ratesReducer,
  contactReducer,
  surveyReducer,
  partnerReducer,
};

export default reducers;
